<template>
  <v-container>
    <DashboardCustomer v-if="isCustomerAdmin" />
    <DashboardAdmin v-else-if="isAdmin" />
  </v-container>
</template>

<script>
// @ is an alias to /src
import DashboardAdmin from "@/components/dashboard/DashboardAdmin";
import DashboardCustomer from "@/components/dashboard/DashboardCustomer";

export default {
  name: "Dashboard",
  data: () => ({
    totalCustomers: 0,
    userStats: null
  }),
  components: { DashboardAdmin, DashboardCustomer },
  methods: {},
  computed: {
    User() {
      return this.$store.getters["user/getUser"];
    },
    isCustomerAdmin() {
      return this.User.role === "customer-admin";
    },
    isAdmin() {
      return this.User.role === "superuser" || this.User.role === "manager";
    }
  },
  beforeCreate() {}
};
</script>
<style scoped></style>
